export const clientVersion = '2025-06-30';
